module.exports = __webpack_public_path__ + "img/device-circle2.595218bd.png";